module.exports = __webpack_public_path__ + "static/media/Citroen-Logo.111657e5.png";